import React from 'react'
import { SingleRangeSlider } from 'neo-react-semantic-ui-range'
import './style.css'
const Slider = (props)=>{    
    return <SingleRangeSlider {...props} />
}

export default Slider